import React, { useState } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import logo from '../assests/img/sbse-logo.jpg';
import './ResultPrint.css';
import { Helmet } from 'react-helmet-async';
import { FaSearch, FaUser, FaBook, FaCheckCircle } from 'react-icons/fa';

function Result() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setResults([]);
    try {
  // Fetch filtered data by regno from the WordPress API endpoint
  const response = await fetch(`https://sbsedelhi.com/backend/wp-json/custom/v1/mytable?regno=${encodeURIComponent(query)}`);
      if (!response.ok) throw new Error("API error");
      const data = await response.json();
      setResults(Array.isArray(data) ? data : []);
    } catch (err) {
      setError("Failed to fetch results.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
       <Helmet>
              <title>SBSE Results | State Board of Secondary Education, Delhi</title>
              <meta name="description" content="Get in touch with the State Board of Secondary Education, Delhi for any queries or support." />
              <meta name="keywords" content="contact, State Board of Secondary Education, Delhi, enquiries, support" />
            </Helmet>
      <Header/>      

      <div className='container main-contant'>
        <div className='inner-page-container'>
          <h1 className='page-title' style={{ textAlign: 'center', fontWeight: 700, marginBottom: 32, fontSize: 32 }}>
            <FaBook style={{ marginRight: 12 }} /> Result Search
          </h1>
          <form className='result-search-form' onSubmit={handleSearch} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 32 }}>
            <input
              type="text"
              value={query}
              onChange={e => setQuery(e.target.value)}
              placeholder="Enter Registration No..."
              style={{ padding: '12px 16px', width: 300, borderRadius: 8, border: '1px solid #ccc', fontSize: 18, marginRight: 12 }}
            />
            <button type="submit" style={{ padding: '12px 24px', borderRadius: 8, background: '#007bff', color: '#fff', border: 'none', fontSize: 18, fontWeight: 600, display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <FaSearch style={{ marginRight: 8 }} /> Search
            </button>
          </form>
          {/* Print Button */}
          {results.length > 0 && (
            <div className='print-btn-box' style={{ textAlign: 'right', marginBottom: 16 }}>
              <button
                onClick={() => window.print()}
                style={{ padding: '10px 28px', background: '#28a745', color: '#fff', border: 'none', borderRadius: 8, fontSize: 18, fontWeight: 600, cursor: 'pointer' }}
              >
                Print Result
              </button>
            </div>
          )}
          {loading && <div style={{ textAlign: 'center', fontSize: 18, color: '#007bff', marginBottom: 16 }}>Loading...</div>}
          {error && <div style={{ color: 'red', textAlign: 'center', fontSize: 16, marginBottom: 16 }}>{error}</div>}
          <div className='row' style={{ justifyContent: 'center' }}>
            {results.length > 0 ? (
              <div>
                {results.map((item, idx) => {
                  let finalTotal = 0;
                  if (item.subjects && Array.isArray(item.subjects)) {
                    finalTotal = item.subjects.reduce((sum, subj) => {
                      const tmarks = Number(subj.tmarks) || 0;
                      const pmarks = Number(subj.pmarks) || 0;
                      return sum + tmarks + pmarks;
                    }, 0);
                  }
                  return (
                    <div key={idx} style={{ border: '1px solid #e0e0e0', borderRadius: 8, background: '#fff', marginBottom: 32, boxShadow: '0 2px 12px #ececec', overflowX: 'auto' }}>
                      {/* Header Info Table */}
                      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 0 }}>
                        <tbody>
                          <tr>
                            <td style={{ padding: 8, fontWeight: 'bold' }}>Name:</td>
                            <td style={{ padding: 8 }}>{item.name || ''}</td>
                            <td style={{ padding: 8, fontWeight: 'bold' }}>Enrollment No :</td>
                            <td style={{ padding: 8 }}>{item.regno || ''}</td>
                            <td style={{ padding: 8, fontWeight: 'bold' }}>Roll :</td>
                            <td style={{ padding: 8 }}>{item.rollno || ''}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: 8, fontWeight: 'bold' }}>No :</td>
                            <td style={{ padding: 8 }}>{item.number || ''}</td>
                            <td style={{ padding: 8, fontWeight: 'bold' }}>Course :</td>
                            <td style={{ padding: 8 }}>{item.course || ''}</td>
                            <td style={{ padding: 8, fontWeight: 'bold' }}>Year of Passing :</td>
                            <td style={{ padding: 8 }}>{item.year || item.pyear || ''}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: 8, fontWeight: 'bold' }}>Session :</td>
                            <td style={{ padding: 8 }}>{item.session || ''}</td>
                            <td style={{ padding: 8, fontWeight: 'bold' }}>Father's Name :</td>
                            <td style={{ padding: 8 }}>{item.father || item.fname || ''}</td>
                            <td style={{ padding: 8 }}></td>
                            <td style={{ padding: 8 }}></td>
                          </tr>
                        </tbody>
                      </table>
                      {/* Subjects Table */}
                      {item.subjects && Array.isArray(item.subjects) && item.subjects.length > 0 && (
                        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 0 }}>
                          <thead>
                            <tr style={{ background: '#2a5db0', color: '#fff' }}>
                              <th style={{ padding: 8, border: '1px solid #e0e0e0' }}>SL. No.</th>
                              <th style={{ padding: 8, border: '1px solid #e0e0e0' }}>Subject</th>
                              <th style={{ padding: 8, border: '1px solid #e0e0e0' }}>Theory Marks</th>
                              <th style={{ padding: 8, border: '1px solid #e0e0e0' }}>Ia/PR Marks</th>
                              <th style={{ padding: 8, border: '1px solid #e0e0e0' }}>Total Marks</th>
                            </tr>
                          </thead>
                          <tbody>
                            {item.subjects.map((subj, sidx) => {
                              const tmarks = Number(subj.tmarks) || 0;
                               const pmarks = subj.pmarks === null || subj.pmarks === undefined || subj.pmarks === "" 
    ? "" 
    : Number(subj.pmarks);
                              const total = tmarks + pmarks;
                              return (
                                <tr key={sidx}>
                                  <td style={{ padding: 8, border: '1px solid #e0e0e0', textAlign: 'center' }}>{sidx + 1}</td>
                                  <td style={{ padding: 8, border: '1px solid #e0e0e0' }}>{subj.subject || ''}</td>
                                  <td style={{ padding: 8, border: '1px solid #e0e0e0', textAlign: 'center' }}>{tmarks}</td>
                                  <td style={{ padding: 8, border: '1px solid #e0e0e0', textAlign: 'center' }}>{pmarks}</td>
                                  <td style={{ padding: 8, border: '1px solid #e0e0e0', textAlign: 'center', fontWeight: 'bold' }}>{total}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                          <tfoot>
                            <tr style={{ background: '#f2f2f2', fontWeight: 'bold' }}>
                              <td colSpan={4} style={{ padding: 8, textAlign: 'right' }}>TOTAL MARKS :</td>
                              <td style={{ padding: 8, textAlign: 'center' }}>{finalTotal}</td>
                            </tr>
                          </tfoot>
                        </table>
                      )}
                      {/* Grade, Division, Result */}
                      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 0 }}>
                        <tbody>
                          <tr style={{ background: '#2a5db0', color: '#fff' }}>
                            <td style={{ padding: 8, fontWeight: 'bold', width: '20%' }}>Grade</td>
                            <td style={{ padding: 8 }}>{item.grade || ''}</td>
                            <td style={{ padding: 8, fontWeight: 'bold', width: '20%' }}>Division</td>
                            <td style={{ padding: 8 }}>{item.division || ''}</td>
                            <td style={{ padding: 8, fontWeight: 'bold', width: '20%' }}>Result</td>
                            <td style={{ padding: 8 }}>{item.result || ''}</td>
                          </tr>
                        </tbody>
                      </table>
                      {/* Description */}
                      <div style={{ padding: 12, fontSize: 15, color: '#333', background: '#f7f7f7', borderTop: '1px solid #e0e0e0' }}>
                        Result Description: P=Pass in Subject, F=Fail in Subject, L=Letter in Subject, *=Star Marks, D=Distinction
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div style={{ textAlign: 'center', color: '#888', fontSize: 18, marginTop: 40 }}>
                No results found. Please enter a valid registration number.
              </div>
            )}
          </div>
        </div>
      </div>
  <Footer className="print-hide" />
    </div>
  );
}

export default Result;
